import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';
import { boxModelStyles } from '../../styles/css';

const StyledFontAwesomeIcon = styled(({ ...props }) => (
  <FontAwesomeIcon {...props} />
))`
  ${({ $size }) => ($size ? `font-size: ${$size}px;` : '')}
  ${boxModelStyles}
`;

export default StyledFontAwesomeIcon;
